<template>
  <div>
    <v-select
      :value="value"
      :class="{ 'ml-3': smAndUp }"
      :items="$attrs?.aggregated_filter_values"
      :label="$attrs?.description"
      append-icon="expand_more"
      :item-text="$attrs?.textField"
      :item-value="$attrs?.valueField"
      :loading="$attrs?.loader"
      :multiple="$attrs?.multiple"
      @change="$emit('change', $event)"
      @focus="checkIfEmpty"
    >
      <template #selection="filter">
        <span v-if="value.length == null">{{ filter?.item?.description }}</span>
        <span v-else-if="value.length === 1">{{ filter?.item[$attrs?.textField] }}</span>
        <span v-else>{{ value.length }} z {{ $attrs?.aggregated_filter_values.length }}</span>
      </template>
    </v-select>
    <p
      v-if="$attrs?.showInfoAlert && isEmptyError"
      class="mb-0 ml-3 link_iconed sz_red--text"
    >
      <v-icon
        color="sz_red"
        class="mr-2"
      >
        error_outline
      </v-icon>
      {{ $attrs?.infoAlertTitle }}
    </p>
  </div>
</template>

<script>
export default {
    name: 'FilterItem',
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: {}
    },
    data () {
        return {
            isEmptyError: false
        };
    },
    computed: {
        smAndUp () {
            return this.$vuetify.breakpoint.smAndUp;
        }
    },
    watch: {
        '$attrs.loader': {
            handler (val) {
                if (val === true) {
                    this.isEmptyError = false;
                }
            }
        }
    },
    methods: {
        checkIfEmpty () {
            const filterValues = this.$attrs?.aggregated_filter_values;
            this.isEmptyError = this.$attrs?.showInfoAlert && filterValues.length === 0;
        }
    }
};
</script>

<style scoped></style>
